module.exports = __webpack_public_path__ + "img/C1.0ffac41c.jpg";